"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const Loader_1 = __importDefault(require("../../Loader"));
const styled_1 = require("./styled");
const BANXA_URL = "https://bitcoincom.banxa.com/";
const BANXA_CODE = "d87817022a88012465f4";
const BanxaWidget = (_a) => {
    var { crypto, fiat, fiatValue, cryptoAmount, walletAddr } = _a, rest = __rest(_a, ["crypto", "fiat", "fiatValue", "cryptoAmount", "walletAddr"]);
    const [loading, setLoading] = (0, react_1.useState)(true);
    const [frameSrc, setFrameSrc] = (0, react_1.useState)("");
    (0, react_1.useEffect)(() => {
        const getFrameUrl = () => __awaiter(void 0, void 0, void 0, function* () {
            try {
                const banxaKey = `code=${BANXA_CODE}`;
                const queries = [banxaKey];
                if (fiatValue)
                    queries.push(`&fiatAmount=${fiatValue}`);
                if (fiat)
                    queries.push(`&fiatType=${fiat}`);
                if (crypto)
                    queries.push(`&coinType=${crypto}`);
                queries.push(`&buyMode`);
                const url = `${BANXA_URL}?${queries.filter(x => x).join("")}`;
                setFrameSrc(url);
            }
            catch (error) {
                // eslint-disable-next-line no-console
                console.log(error);
            }
        });
        getFrameUrl();
    }, [crypto, cryptoAmount, fiat, fiatValue, walletAddr]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        loading && (react_1.default.createElement(styled_1.LoaderContainer, null,
            react_1.default.createElement(Loader_1.default, null))),
        frameSrc && (react_1.default.createElement("iframe", Object.assign({ title: "Banxa Widget", allow: "geolocation", height: "500px", width: "100%", style: { border: 0 }, src: frameSrc, onLoad: () => {
                setLoading(false);
            } }, rest)))));
};
exports.default = BanxaWidget;
//# sourceMappingURL=BanxaWidget.js.map